import { getLocale } from 'i18n/locale';
import { ELocale } from 'i18n/localeEnum';

// FIXME: get rid of if no need
export function hasKayakIntegration() {
  const locale = getLocale() as ELocale;
  const isKayaked = [ELocale.EN_US, ELocale.FR_FR].includes(locale);

  return isKayaked;
}
